module.exports = __webpack_public_path__ + "img/lantern-on.e7ca34db.png";